// fetch with GET does not allow body data
export function getApi(url, headers=false) {
	if(window.token) {
		if (headers) {
			headers.RequestVerificationToken = window.token;
		} else {
			headers = {
				RequestVerificationToken: window.token
			};
		}
	}

	return fetch(url, {
		credentials: 'same-origin',
		//headers: {
		//	'Content-Type': 'application/json',
		//},
		headers: (headers) ? new Headers(headers) : new Headers({})
	})
	.then((response) => response.json())
	.then((response) => Promise.resolve(response))
	.catch((error) => {
		Promise.reject(error);
		$('.loading-spinner').removeClass('is-active');
	});
}

// fetch with POST and others (DELETE, etc.)
export function callApi(url, data = {}, method = 'POST') {
	const headers = {
		'Content-Type': 'application/json'
	};

	if(window.token) {
		headers.RequestVerificationToken = window.token;
	}

	return fetch(url, {
		method: method,
		body: JSON.stringify(data),
		credentials: 'same-origin',
		headers: new Headers(headers),
	})
		.then((response) => response.json())
		.then((response) => Promise.resolve(response))
		.catch((error) => {
			Promise.reject(error);
			$('.loading-spinner').removeClass('is-active');
		});
}

export function getHtml(url, data = {}, method = 'POST') {
	const headers = {};

	if (window.token) {
		headers.RequestVerificationToken = window.token;
	}

	return $.ajax({
		url,
		method,
		headers,
		data,
	}).always(() => {
		$('.loading-spinner').removeClass('is-active');
	});
}



// WEBPACK FOOTER //
// ./api.js